/* jshint esversion: 6 */
import React from 'react';
import { createRoot } from 'react-dom/client';

import AppSwitcher from 'app/components/common/AppSwitcher.jsx';

import { IntlProvider } from 'react-intl';

import { APIProvider } from '@vis.gl/react-google-maps';

import { Provider } from 'react-redux';
import { AppActions } from 'app/redux/actions.js';
import { DlvrStore } from 'app/redux/configureStore.js';
import { setDefaultBreakpoints, BreakpointProvider } from 'react-socks';
import { bootIntercom } from 'app/utility/Intercom.js';
import { dropForeignExceptions } from 'app/utility/PostHogExceptionFilter.js';

import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';

setDefaultBreakpoints([
	{mobile: 0},
	{desktop: 769}
]);

// monkeypatch for google translate issues
// more info here:
// https://github.com/facebook/react/issues/11538#issuecomment-417504600
if (typeof Node === 'function' && Node.prototype) {
	const originalRemoveChild = Node.prototype.removeChild;
	Node.prototype.removeChild = function(child) {
		if (child.parentNode !== this) {
			if (console) {
				console.error('Cannot remove a child from a different parent', child, this);
			}
			return child;
		}
		return originalRemoveChild.apply(this, arguments);
	};

	const originalInsertBefore = Node.prototype.insertBefore;
	Node.prototype.insertBefore = function(newNode, referenceNode) {
		if (referenceNode && referenceNode.parentNode !== this) {
			if (console) {
				console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
			}
			return newNode;
		}
		return originalInsertBefore.apply(this, arguments);
	};
}

const container = document.getElementById('dlvr-app');
const root = createRoot(container);

DlvrStore.dispatch(AppActions.appBootstrap());

bootIntercom();

posthog.init('phc_pAazons7nnBUAnbwgSAdBnKyehwN4pxJ4HdbTMfoJBbP', {
	api_host: 'https://us.i.posthog.com',
	defaults: '2026-05-30',
	person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
	before_send: dropForeignExceptions,
});

// posthog.debug(true);

root.render(
    <IntlProvider locale="en">
        <Provider store={DlvrStore}>
            <BreakpointProvider>
				<APIProvider apiKey="AIzaSyBwRDYQrk-_HcDAvxJID0fq2Fx6patXO1Y">
					<PostHogProvider client={posthog}>
                		<AppSwitcher/>
					</PostHogProvider>
				</APIProvider>
            </BreakpointProvider>
        </Provider>
    </IntlProvider>
);
